export default __webpack_public_path__ + "static/media/jump.cf0c02cc.png";